import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "ds-smile-static__inner" }
const _hoisted_2 = { class: "ds-smile-static__body" }
const _hoisted_3 = ["src", "width", "height"]
const _hoisted_4 = ["src", "width", "height"]

import { computed } from "vue";
import { DsSmileStaticFacePosition, DsSmileStaticFaceType } from "./ds-smile-static-types";


export default /*@__PURE__*/_defineComponent({
  __name: 'ds-smile-static',
  props: {
    faceType: { default: DsSmileStaticFaceType.DefaultSmile },
    facePosition: { default: DsSmileStaticFacePosition.Center },
    withShadow: { type: Boolean, default: true },
    responsive: { type: Boolean, default: true },
    size: { default: "default" },
    shadowColor: { default: "orange" },
    width: {},
    height: {},
    isInStorybook: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props;

const resolvedBody = computed(() => {
    if (props.isInStorybook) return "/images/img/design-system/smiles/smile-static/body.svg";

    return "/frontend/web/img/design-system/smiles/smile-static/body.svg";
});

const resolvedFace = computed(() => {
    if (props.isInStorybook)
        return `/images/img/design-system/smiles/smile-static/face/${props.faceType}--${props.facePosition}.svg`;

    return `/frontend/web/img/design-system/smiles/smile-static/faces/${props.faceType}--${props.facePosition}.svg`;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["ds-smile-static", {
            'ds-smile-static--with-shadow': _ctx.withShadow,
            'ds-smile-static--responsive': _ctx.responsive,
            'ds-smile-static--contain': _ctx.size === 'contain',
        }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("img", {
          src: resolvedBody.value,
          alt: "Kulicnik bg",
          class: "ds-smile-static__bg",
          width: _ctx.width,
          height: _ctx.height
        }, null, 8, _hoisted_3),
        _createElementVNode("img", {
          src: resolvedFace.value,
          alt: "Kulicnik bg",
          class: "ds-smile-static__face",
          width: _ctx.width,
          height: _ctx.height
        }, null, 8, _hoisted_4)
      ]),
      (_ctx.withShadow)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(["ds-smile-static__shadow", [_ctx.shadowColor !== 'orange' && `ds-smile-static__shadow--${_ctx.shadowColor}`]])
          }, null, 2))
        : _createCommentVNode("", true)
    ])
  ], 2))
}
}

})